import React, { Component } from 'react';
import { ScrollSyncPane } from 'react-scroll-sync'
import { push } from 'react-router-redux'
import { NavLink } from 'react-router-dom'
import '../stylesheets/inventory.sass'
import _ from 'lodash'
import moment from 'moment'
export default class TipRow extends Component {

  render() {
    return(
      <div className='customer_row'>
        { this.props.tip &&
          this.props.tip['attributes'] &&
        <div className='customer_row_wrapper'>
          <div className='customer_col_one'>
          </div>
          <div className='column-one customer-col name'>
            <div>
              { this.props.tip['attributes']['tipIdTipId']}
            </div>
          </div>
          <ScrollSyncPane>
            <div className='scroll'>
              <div className='customer-col quarter-slim'>
                <div>
                  ${
                    (Number(this.props.tip['attributes']['tipIdAmount'])/100).toFixed(2)
                  }
                </div>
              </div>
            </div>
          </ScrollSyncPane>
        </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Accounting/TipRow.jsx